export function formatText(txt?: string): string {
  if (!txt) return ''
  return txt
    .replace(/\(TM\)/g, '<sup>\u2122</sup>') // TM
    .replace(/\(r\)/g, '<sup>\u00AE</sup>') // REGISTERED SIGN
}

export function formatTime(time?: number): string {
  if (time == null) return ''
  const timeInSeconds = Math.floor(time / 1000)
  const minutes = Math.floor(timeInSeconds / 60)
  let seconds: string | number = Math.floor(timeInSeconds % 60)
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `(${minutes}:${seconds})`
}
